module.exports = __webpack_public_path__ + "static/media/stopwatch.5ad95321.svg";